import usePitchListStore from 'components/sections/pitch-list/store/use-pitch-list-store';
import env from 'config';
import { MachineContext } from 'contexts/machine.context';
import { TrackingDevice } from 'lib_ts/enums/training.enums';
import { useContext, useEffect } from 'react';

// automatically close recap when active list changes
const useSyncRecapToggle = () => {
  const { machine } = useContext(MachineContext);

  useEffect(() => {
    if (env.identifier === 'local') {
      // * locally, don't mess with the flag for testing recap via mock rapsodo
      return;
    }

    switch (machine.tracking_device) {
      case TrackingDevice.TrajektVision: {
        usePitchListStore.setState({ showRecap: true });
        return;
      }

      default: {
        usePitchListStore.setState({ showRecap: false });
        return;
      }
    }
  }, [machine.tracking_device]);
};

export default useSyncRecapToggle;
